import React from 'react';
import styled, { keyframes } from 'styled-components';

const spinnerAnimation = keyframes`
100% {transform: rotate(1turn)}
`;

const Spinner = styled.div`
  width: 35px;
  height: 35px;
  display: grid;
  border-radius: 50%;
  border: 5px solid ${props => props.theme.colors.primary};
  border-right-color: ${props => props.theme.colors.secondary};
  position: relative;
  animation: ${spinnerAnimation} 1s infinite linear;

  &::before,
  &::after {
    content: "";
  position: absolute;
  inset:-4px;
  border-radius: 50%;
  border:inherit;
  animation:inherit;
  animation-duration: 2s;
  }

  &::after {
    animation-duration: ${spinnerAnimation};
  }
`;

const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 8vh; /* Adjust this if you want a different height */
`;

export default () => (
  <CenteredContainer>
    <Spinner />
  </CenteredContainer>
);
